(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eo-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ever-oak-hero')) {
    customElements.define('ever-oak-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-eo-target]');
          if (!button) return;
          this.querySelectorAll('[data-eo-slide]').forEach(slide => { slide.hidden = slide.dataset.eoSlide !== button.dataset.eoTarget; });
          this.querySelectorAll('[data-eo-target]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
